import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { ErpWorkflowOperationComponent } from './erpworkflowoperation.component';

@Component({
    selector: 'erp-workflow-testform',
    templateUrl: './erpworkflowtestform.component.html'
})
export class ErpWorkflowTestformComponent implements OnInit {
    @ViewChild(ErpWorkflowOperationComponent) workflowComponent!: ErpWorkflowOperationComponent;
    formSaved: Subject<any> = new Subject();
    useCaseChanged: Subject<any> = new Subject();
    attributes: any[] = [];
    attributeSelectForm = this.formBuilder.group({
        attributesFC: '',
        processIdFC: ''
    });
    selectedAttribute: any;
    selectedProcessId!: number;

    constructor(
        private formBuilder: FormBuilder

    ) { }

    loadAttributes() {
        this.workflowComponent.availableNextResponsiblePersonValues = [];
        this.workflowComponent.availableProcessingStepValues = [];
        this.workflowComponent.filteredNextResponsiblePersonValues = [];
        this.workflowComponent.filteredProcessingStepValues = [];
        this.workflowComponent.processId = this.selectedProcessId;
        this.workflowComponent.processType = this.selectedAttribute.type;
        this.workflowComponent.useCaseIdent = this.selectedAttribute.useCase;
        this.workflowComponent.updateProcessingStepAndNextResponsiblePersonLists();
    }

    notifyParentSaved() {
        this.formSaved.next(1);
    }

    ngOnInit(): void {
        this.attributes = [
            {type: 'ura', useCase: 'ura_neu'},
            {type: 'ura', useCase: 'ura_bearbeiten'},
            {type: 'ura', useCase: 'ura_weiterverarbeiten'},
            {type: 'dra', useCase: 'dra_neu'},
            {type: 'dra', useCase: 'dra_bearbeiten'},
            {type: 'dra', useCase: 'dra_weiterverarbeiten'},
            {type: 'rka', useCase: 'rka_neu'},
            {type: 'rka', useCase: 'rka_bearbeiten'},
            {type: 'rka', useCase: 'rka_weiterverarbeiten'},
            {type: 'sas', useCase: 'sas_neu'},
            {type: 'sas', useCase: 'sas_bearbeiten'},
            {type: 'sas', useCase: 'sas_weiterverarbeiten'},
            {type: 'zeb', useCase: 'zeb_neu'},
            {type: 'zeb', useCase: 'zeb_bearbeiten'},
            {type: 'zeb', useCase: 'zeb_weiterverarbeiten'},
            {type: 'fba', useCase: 'fba_neu'},
            {type: 'fba', useCase: 'fba_bearbeiten'},
            {type: 'fba', useCase: 'fba_weiterverarbeiten'},
        ];
    }

}
